import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../../api/queries/homeQueries";
import Utils from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import ProdCard from "../../../components/box/ProdCard";
import { UI } from "../../../config/ui";
import { UiTitle } from "../../../components/text/UiTitle";

interface EsimSwiperProps {}

const EsimSwiper: React.FC<EsimSwiperProps> = () => {
  const { handleSlideChange, products } = useHomeProducts("SIM", "sims");
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col justify-center gap-4 sm:gap-10">
      <UiTitle text={t("SIM/eSIM")} />
      <div className="relative">
        {!!products?.length && (
          <Swiper
            modules={[Navigation]}
            onSlideChange={handleSlideChange}
            slidesPerView={"auto"}
            spaceBetween={16}
            breakpoints={{
              [UI.sm]: {
                slidesPerView: 4,
                spaceBetween: Utils.remToPx(1.5),
              },
            }}
            navigation={{
              nextEl: "#rcmd-esim-next",
              prevEl: "#rcmd-esim-prev",
            }}
            className="esim-swiper prod-card-swiper"
          >
            {products.map((product, index) => (
              <SwiperSlide className="white-shaddow-15 !h-auto" key={index}>
                <ProdCard {...product} contentOnly={true} home={true} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <div className="swiper-button-prev" id="rcmd-esim-prev">
          <img src="../../../assets/icons/swiper_prev_arrow.svg" alt="" />
        </div>
        <div className="swiper-button-next" id="rcmd-esim-next">
          <img src="../../../assets/icons/swiper_next_arrow.svg" alt="" />
        </div>
      </div>
    </div>
  );
};
export default EsimSwiper;
